/**
 * UED 设计的一套表头列宽 常量
 * https://bytedance.feishu.cn/docs/doccnG5Ydw8egkYrBCGCWq0Arqg#Rlzqiz
 */

// 表头列宽对应的规格
export const COLUMN_WIDTH = {
  XS: 56,
  S: 88,
  M: 120,
  L: 152,
  XL: 184,
  XXL: 216,
};
